/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

import {MAX_CONTENT_WIDTH} from '../../constants';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

interface DropzoneProps {
  dragOver: boolean;
}

export const Dropzone = styled(Box, {
  shouldForwardProp: prop => prop !== 'dragOver',
})<DropzoneProps>(({theme, dragOver}) => ({
  width: 'max-content',
  border: `1px dashed ${dragOver ? theme.palette.semantic_light?.surface.inverseSurface : theme.palette.semantic_light?.surface.surface2}`,
  borderRadius: '8px',
}));

export const ErrorText = styled(Typography)(({theme}) => ({
  color: theme.palette.error.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const ResultBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  maxWidth: `${MAX_CONTENT_WIDTH}px`,
  gap: theme.spacing(2),
}));

export const ScreenshotBorderBox = styled(Box)(({theme}) => ({
  width: '96px',
  height: '96px',
  borderRadius: '8px',
  border: `2px solid ${theme.palette.figma_surface?.light}`,
  position: 'relative',
  overflow: 'hidden',
}));

export const RemoveButton = styled(Button)(({theme}) => ({
  width: '32px',
  height: '32px',
  minWidth: 'unset',
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 1,

  '&:hover': {
    background: `${theme.palette.semantic_light?.bad.hover}33`,
  },

  '.MuiSvgIcon-root': {
    fontSize: '16px',
    color: theme.palette.semantic_light?.bad.main,
  },
}));

export const ScreenshotImg = styled('img')(() => ({
  position: 'relative',
  zIndex: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
}));
